import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Analytics/Analytics.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/AnimatedNumber/AnimatedNumber.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Link/Link.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ReactSlickSlider/ReactSlickSlider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/wrappers/index.tsx");
